export default __webpack_public_path__ + "static/media/icon_new-article.c2b10dd9.svg";